declare const ngDevMode: boolean;
/**
 * Set by Angular to true when in development mode.
 * Allows for tree-shaking code that is only used in development.
 */
export const brnDevMode = ngDevMode;
